<template>
  <el-carousel
    id="carousel"
    class="carousel"
    :interval="0"
    indicator-position="outside"
    height="530px"
    :arrow="arrow"
    direction="horizontal"
  >
    <el-carousel-item
      v-for="(productGroup, i) in productGroups"
      id="carousel-item"
      :key="i"
    >
      <div class="product-div">
        <el-col
          v-for="product in productGroup"
          :key="product.puid"
          :span="isMobileLayout() ? 24 : 8"
        >
          <ProductCard
            :productType="productType"
            :product="product"
            :is-carousel="true"
            :is-providers="true"
            :backBtnName="backBtnName"
            :taxCode="taxCode"
          />
        </el-col>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { forEach } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import ProductCard from "@/views/product/components/product-card.vue";

export default {
  components: {
    ProductCard,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    arrow: {
      type: String,
      default: "always",
    },
    backBtnName: {
      type: String,
      default: "",
    },
    productType: {
      type: String,
      default: "",
    },
    taxCode: {
      type: String,
      default: "IN",
    },
  },
  data() {
    return {};
  },
  computed: {
    productGroups() {
      const groups = [];
      let group = [];
      const perSlide = this.isMobileLayout() ? 1 : 3;
      forEach(this.products, (p) => {
        group.push(p);
        if (group.length >= perSlide) {
          groups.push([...group]);
          group = [];
        }
      });

      if (group.length > 0) {
        groups.push([...group]);
      }
      return groups;
    },
  },
  methods: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
.el-carousel__item {
  background-color: $color-background;
}
.carousel {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
  .product-div {
    width: 100%;
    display: inline-flex;
    gap: 15px;
  }
}
</style>
